import UpdateForecastFormDto from 'types/PrpTable/dto/UpdateForecastFormDto';

const UpdateForecastFormDefaultValue = (defaultForecast: number): UpdateForecastFormDto => {
  return {
    forecastLength: Number(defaultForecast.toFixed(2))
  };
};

export default UpdateForecastFormDefaultValue;
